import {
  ADJUSMENT_PLACEMENT_SUCCESS,
  LAST_CAPTURE_FAILURE,
  LAST_CAPTURE_LOADING,
  LAST_CAPTURE_SUCCESS,
  PRODUCTS_FAILURE,
  PRODUCTS_LOADING,
  PRODUCTS_SUCCESS,
} from './constants';
import { createReducer } from './utils';
import { createAbort, ABORT_KEYS } from './utils/abortManager';

const defaultState = {
  loading: false,
  products: {},
  adjustment: [],
  placement: [],
  errorMessage: null,
  captures: [],
  loading_captures: false,
  emptyCaptures: false,
};

// reducer

export const reducer = createReducer(defaultState, {
  [PRODUCTS_LOADING]: handleProductsLoading,
  [PRODUCTS_SUCCESS]: handleProductsSuccess,
  [PRODUCTS_FAILURE]: handleProductsFailure,
  [ADJUSMENT_PLACEMENT_SUCCESS]: handleAdjusmentPlacementSuccess,
  [LAST_CAPTURE_LOADING]: handleLastCaptureLoading,
  [LAST_CAPTURE_SUCCESS]: handleLastCaptureSuccess,
  [LAST_CAPTURE_FAILURE]: handleLastCaptureFailure,
});

function handleProductsLoading(state, action) {
  return {
    ...state,
    loading: true,
    products: {},
    adjustment: [],
    placement: [],
  };
}

function handleProductsSuccess(state, { payload: { products } }) {
  return {
    ...state,
    loading: false,
    products: products,
  };
}

function handleProductsFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    products: {},
    errorMessage: error,
  };
}

function handleAdjusmentPlacementSuccess(
  state,
  { payload: { adjustment, placement } },
) {
  return {
    ...state,
    adjustment: adjustment,
    placement: placement,
  };
}

function handleLastCaptureLoading(state, action) {
  return {
    ...state,
    loading_captures: true,
    captures: [],
    emptyCaptures: false,
  };
}

function handleLastCaptureSuccess(
  state,
  { payload: { captures, emptyCaptures } },
) {
  return {
    ...state,
    loading_captures: false,
    captures: captures,
    emptyCaptures: emptyCaptures,
  };
}

function handleLastCaptureFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading_captures: false,
    captures: [],
    errorMessage: error,
    emptyCaptures: true,
  };
}

// actions
function checkStock(stock_info, type) {
  if (stock_info !== null && typeof stock_info === 'object') {
    if (type === 'available') {
      return stock_info['stock_available'] !== undefined
        ? stock_info['stock_available']
        : stock_info['stock_on_hand'] !== undefined
          ? stock_info['stock_on_hand']
          : null;
    }
    if (type === 'transit') {
      return stock_info.hasOwnProperty('stock_in_transit')
        ? stock_info['stock_in_transit']
        : null;
    }
  } else {
    return null;
  }
}

export function getProductsInfo(signal) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: PRODUCTS_LOADING });
    const {
      stores: { currentStore },
      search: { reportParameters },
    } = getState();

    const abortSignal = signal ?? createAbort(ABORT_KEYS.PRODUCT_INFO);

    try {
      let products = {};
      let adjustment = [];
      let placement = [];
      const response = await dataSource.requestProductsInfo({
        store: currentStore,
        item: reportParameters['item'],
        ean: reportParameters['ean'],
        signal: abortSignal,
      });

      products['description'] = response['description'];
      products['item'] = response['item'];
      products['ean'] = response['ean'];
      products['price'] = response['price']['pos_price'];
      products['stock'] = checkStock(response['stock']['status'], 'available');
      products['transit_stock'] = checkStock(
        response['stock']['status'],
        'transit',
      );

      dispatch({ type: PRODUCTS_SUCCESS, payload: { products } });

      if (response['adjustment'].length !== 0) {
        adjustment = response['adjustment'];
      }

      if (response['placement'].length !== 0) {
        placement = response['placement'];
      }

      dispatch({
        type: ADJUSMENT_PLACEMENT_SUCCESS,
        payload: { adjustment, placement },
      });
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.log('getProductsInfo error', error);
      dispatch({
        type: PRODUCTS_FAILURE,
        payload: { error },
      });
    }
  };
}

export function getLastCaptures(signal) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: LAST_CAPTURE_LOADING });
    const {
      stores: { currentStore },
      search: { reportParameters },
    } = getState();

    const abortSignal = signal ?? createAbort(ABORT_KEYS.PRODUCT_CAPTURES);

    try {
      const response = await dataSource.requestLastSeen({
        store: currentStore,
        item: reportParameters['item'],
        ean: reportParameters['ean'],
        signal: abortSignal,
      });

      const captures = [];
      let emptyCaptures = false;

      response.map(data => {
        if (typeof data === 'object') {
          if (data['url'] !== null || data['metadata']?.encoded_image) {
            captures.push(data);
          }
        }
      });

      if (captures.length === 0) {
        emptyCaptures = true;
      }

      dispatch({
        type: LAST_CAPTURE_SUCCESS,
        payload: { captures, emptyCaptures },
      });
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.log('getLastCaptures error', error);
      dispatch({
        type: LAST_CAPTURE_FAILURE,
        payload: { error },
      });
    }
  };
}
